import { buildParams } from '../../helpers/path';
import { getMenuId } from '../../pages/manager/body/menu/menu-informer/menu-informer-helpers';
import { IdValue } from '../../types/props';
import { DishMenuType } from './dish-menu-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type IikoMenuType = {
  terminal_groups: IdValue[];
} & DishMenuType;

export type IikoCreadentialType = {
  id: number;
  api_login: string;
};

const baseUrl = `${managerApiUrl}/menu/iiko`;

export const fetchIikoCredentials = async (): Promise<{
  data: IikoCreadentialType;
}> => {
  const response = await baseFetch(baseUrl + '/credentials');
  return response;
};

export const putIikoCredentials = async (
  params: Partial<IikoCreadentialType>,
): Promise<IikoCreadentialType> => {
  const response = await baseFetch(baseUrl + '/credentials', {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const postIikoCredentials = async (
  params: Partial<IikoCreadentialType>,
): Promise<IikoCreadentialType> => {
  const response = await baseFetch(baseUrl + '/credentials', {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

export type FetchMenuIikoListRequest = {
  branch_id: string;
};

export const fetchIikoMenuList = async (
  params: FetchMenuIikoListRequest,
): Promise<{
  menus: IikoMenuType[];
}> => {
  const url = baseUrl + buildParams(params);
  const response = await baseFetch(url);
  return response;
};

export const putIikoMenu = async (
  data: Partial<IikoMenuType>,
): Promise<{
  menu: IikoMenuType;
}> => {
  const terminal_group_ids = data.terminal_groups?.map((item) => item.id) || [];

  const response = await baseFetch(baseUrl, {
    method: 'PUT',
    body: JSON.stringify({
      ...data,
      terminal_group_ids,
      menu_id: getMenuId(),
    }),
  });
  return response;
};

export const fetchIikoMenu = async (
  id: string,
): Promise<{
  menu: IikoMenuType;
}> => {
  const response = await baseFetch(baseUrl + '/' + id);
  return response;
};

export const syncIikoMenu = async (branch_id?: string): Promise<void> => {
  await baseFetch(baseUrl + '/sync', {
    method: 'POST',
    body: JSON.stringify({ branch_id }),
  });
};

export const putIikoMenuOrder = async (order: string[]) => {
  const response = await baseFetch(baseUrl + `/order`, {
    method: 'PUT',
    body: JSON.stringify({ order }),
  });
  return response;
};

export type FetchMenuIikoTerminalsRequest = {
  branch_id: string;
};

export const fetchIikoTerminals = async (
  params: FetchMenuIikoTerminalsRequest,
): Promise<IdValue[]> => {
  const resp = await baseFetch(baseUrl + '/terminals' + buildParams(params));
  return resp.data;
};
